/**
 * Shared utility functions for keyword management
 */

/**
 * Parse bulk input and extract keywords
 * Handles Excel data with common delimiters: newlines, tabs, commas, semicolons
 */
export const parseBulkKeywords = (input: string, existingKeywords: string[] = []): string[] => {
  if (!input.trim()) return [];
  
  // Split by common delimiters: newlines, tabs, commas, semicolons
  const keywords = input
    .split(/[\n\t,;]/)
    .map(keyword => keyword.trim())
    .filter(keyword => keyword.length > 0)
    .filter(keyword => !existingKeywords.includes(keyword)); // Remove duplicates
  
  return keywords;
};

/**
 * Add bulk keywords to existing keywords array
 * Returns the updated array with new keywords added
 */
export const addBulkKeywords = (existingKeywords: string[], newKeywords: string[]): string[] => {
  const uniqueNewKeywords = newKeywords.filter(keyword => !existingKeywords.includes(keyword));
  return [...existingKeywords, ...uniqueNewKeywords];
};
